<template>
  <div class="admin">
    <transition name="fade" mode="out-in">
      <div v-if="token" key="signed-in">
        <h2 class="section-title">Panel administratora</h2>
        <div class="columns">
          <div class="column is-12">
            <div class="admin-card card">
              <div class="card-content">
                <div class="columns">
                  <div class="column is-narrow">
                    <admin-menu @go-to="goTo" @sign-out="signOut" />
                  </div>
                  <div class="column">
                    <router-view
                      @push-notification="$emit('push-notification', $event)"
                      @show-modal="$emit('show-modal', $event)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="signing-in" v-else-if="exchangeToken" key="signin-in">
        <span class="signing-in__spinner" />
      </div>

      <div class="columns" v-else key="signed-out">
        <div
          class="column is-6-tablet is-4-widescreen is-offset-3-tablet is-offset-4-widescreen"
        >
          <admin-login @send-request="requestExchangeToken" />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState } from "vuex";

import { CLEAR_TOKEN, CLEAR_SENSITIVE_META_INFO } from ":mutations";

import {
  REQUEST_EXCHANGE_TOKEN,
  REQUEST_TOKEN,
  REQUEST_META_INFO
} from ":actions";

import AdminMenu from "%admin/AdminMenu";
import AdminLogin from "%admin/AdminLogin";

import {
  ExchangeTokenSentNotification,
  SignOutNotification
} from "%notifications";

export default {
  name: "admin",

  components: {
    AdminMenu,
    AdminLogin
  },

  props: {
    exchangeToken: String
  },

  computed: mapState({
    token: state => state.security.token
  }),

  mounted() {
    this.tryToRequestToken();
  },

  methods: {
    async tryToRequestToken() {
      if (this.exchangeToken) {
        this.$store
          .dispatch(REQUEST_TOKEN, { exchangeToken: this.exchangeToken })
          .then(() => this.$router.push("/admin"))
          .then(() => this.$store.dispatch(REQUEST_META_INFO));
      }
    },

    requestExchangeToken(mailAddress) {
      this.$store.dispatch(REQUEST_EXCHANGE_TOKEN, { mailAddress }).then(() =>
        this.$emit("push-notification", {
          component: ExchangeTokenSentNotification,
          props: {
            sendAgain: () => this.requestExchangeToken(mailAddress),
            mailAddress
          }
        })
      );
    },

    goTo(name) {
      this.$router.push({ name });
    },

    async signOut() {
      this.$store.commit(CLEAR_TOKEN);
      this.$store.commit(CLEAR_SENSITIVE_META_INFO);
      this.$emit("push-notification", { component: SignOutNotification });
      await this.$router.push("/");
      this.$immediatelyScrollToTop();
    }
  }
};
</script>

<style lang="scss" scoped>
.admin {
  background: url(../assets/img/bubbles.svg) no-repeat center / cover,
    linear-gradient(10deg, $info, $primary, $primary2);
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 5rem 1rem;

  @include until($small-mobile) {
    padding: 5rem 0.3rem;
  }

  &-card {
    overflow: hidden;
  }
}

.signing-in {
  display: flex;
  justify-content: center;
  align-items: center;

  &__spinner {
    @include loader;
    font-size: 10rem;
    border-width: 20px;
    animation-duration: 1s;
    border-left-color: $white;
    border-bottom-color: $white;
  }
}
</style>
